import { dangerColor, successColor } from '../global';

const SettingBoothStyle = {
    room: {
        padding: '20px 20px 0',
        marginBottom: '50px',
    },
    name: {
        '& input': {
            padding: '6px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    timeRemoveButton: {
        color: dangerColor,
    },
    timeAddButton: {
        color: successColor,
    },
    roomAddButton: {
        marginLeft: '-8px',
        color: successColor,
    },
    roomRemoveButton: {
        position: 'absolute',
        right: '20px',
        color: dangerColor,
        zIndex: 1,
    },
    timeWrapper: {
        padding: 0,
    },
    apply: {
        display: 'block',
        margin: '50px 0 50px auto',
    },
    numberInput: {
        width: '70px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
};

export default SettingBoothStyle;
